import { jsx as _jsx } from "react/jsx-runtime";
import { TooltipProvider } from '@/components/ui/tooltip';
/**
 * Providers raiz do app.
 * Futuro: ThemeProvider, QueryClientProvider, Toaster, I18n.
 */
export function Providers({ children }) {
    return (_jsx(TooltipProvider, { delayDuration: 150, skipDelayDuration: 80, children: children }));
}
